import type React from 'react';

import { JsonSchemaInput } from '@ragu-components/json-schema-input';
import {
  OrdFormList,
  OrdIconStandard,
  OrdReferenceArrayInput,
  OrdReferenceInput,
  OrdTabbedForm,
  useFormType,
} from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { HuntingGroupUpdateFields, dataSchema } from '@ragu-components/ord-types';
import { TabbedForm, useRecordContext } from 'react-admin';

import { OrdDescriptionInput } from 'src/components/formInputs';

import type { OrdTabbedFormProps } from '@ragu-components/ord-components';
import type { HuntingGroup } from '@ragu-components/ord-types';

export const HuntingGroupsForm = ({
  embedded = false,
  ...props
}: OrdTabbedFormProps & { embedded?: boolean }): React.ReactElement => {
  const { create } = useFormType();
  const record = useRecordContext<HuntingGroup>();

  return (
    <OrdTabbedForm
      sanitizeFields
      replaceRelationships
      createJsonSchema={dataSchema.HuntingGroupCreate}
      editJsonSchema={dataSchema.HuntingGroupUpdate}
      syncWithLocation={false}
      deleteProps={create ? { disabled: true } : undefined}
      {...props}
    >
      <TabbedForm.Tab label='resources.hunting_groups.operations.sections.details'>
        <OrdFormList icon={<OrdIconStandard name='name' />}>
          <JsonSchemaInput source={HuntingGroupUpdateFields.name} />
        </OrdFormList>
        <OrdFormList icon={<OrdIconStandard name='description' />}>
          <OrdDescriptionInput source={HuntingGroupUpdateFields.description} />
        </OrdFormList>
        <OrdFormList icon={<OrdIconStandard name='person' />}>
          <OrdReferenceInput
            defaultValue={record?.owner}
            readOnly={embedded}
            source={HuntingGroupUpdateFields.owner}
            resource={Resources.users}
            helperText='resources.hunting_groups.helperTexts.owner'
          />
        </OrdFormList>
        <OrdFormList icon={<OrdIconStandard name='numbers' />}>
          <OrdReferenceArrayInput
            resource={Resources.user_numbers}
            source={HuntingGroupUpdateFields.user_numbers}
            filter={{
              fiql:
                record?.owner !== undefined && typeof record?.owner === 'string'
                  ? `owner.id==${record.owner as string}`
                  : undefined,
            }}
          />
        </OrdFormList>
      </TabbedForm.Tab>
    </OrdTabbedForm>
  );
};
